import { render, staticRenderFns } from "./field-date-input-format.vue?vue&type=template&id=08a45b14&scoped=true&"
import script from "./field-date-input-format.vue?vue&type=script&lang=js&"
export * from "./field-date-input-format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a45b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
